import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import Delivery from "../../components/customerHandling/modelEDetails/Delivery";

const NewDelivery = ({ orderId, content }) => {
  const { customerInfo } = content;
  const vehicleInfo = {
    namePlate: content.customerReservation.nameplate,
    modelYear: content.customerReservation.modelYear,
    vin: content.customerReservation.vinNumber,
  };

  return (
    <Box
      display="grid"
      gridTemplateColumns="repeat(12, 1fr)"
      columnGap={4}
      rowGap={4}
    >
      <Box
        gridColumn={{
          xs: "span 12",
        }}
      >
        <Delivery
          orderId={orderId}
          customerInfo={customerInfo}
          vehicleInfo={vehicleInfo}
          setCustomerFollowupNotification={() => {}}
        />
      </Box>
    </Box>
  );
};

NewDelivery.propTypes = {
  orderId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  content: PropTypes.shape({
    customerInfo: PropTypes.object.isRequired,
    customerReservation: PropTypes.shape({
      nameplate: PropTypes.string,
      modelYear: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      vinNumber: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

export default NewDelivery;
